import SidebarLayout from '../components/SidebarLayout';
import React, { useState, useEffect, useContext } from 'react';
import AuthContext from '../context/AuthContext';
import ActionsAndChecksTable from '../components/sections/Dashboard/ActionsAndChecksTable';
import AccessWrapper from '../components/AccessWrapper';
import { useNavigate } from 'react-router-dom';

export default function ActionsAndChecks() {
  let { authTokens, user, postPageView, baseUrl } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  /* state variables to hold json data from the back-end */
  let [actionsAndChecks, setActionsAndChecks] = useState([]);

  /* state variables to hold form data to submit to the back-end */

  useEffect(() => {
    getActionsAndChecks();
    postPageView(baseUrl, user.name, user.role, 'actions-and-checks');
  }, []);

  let getActionsAndChecks = async () => {
    setLoading(true);
    let response = await fetch(
      `${baseUrl}/mtss/interventions/caregiver_or_supervisor_of/`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + String(authTokens.access),
        },
      },
    );
    let data = await response.json();

    if (response.status === 200) {
      setActionsAndChecks(data);
      setLoading(false);
    } else if (response.status === 403) {
      setLoading(false);
      navigate('/unauthorized');
    }
  };

  return (
    <AccessWrapper
      allowedGroups={['mtss_member', 'mtss_supervisor', 'mtss_admin']}
    >
      <div>
        <SidebarLayout
          propComponents={
            <div className='pb-12 sm:pb-16 lg:pb-20'>
              <ActionsAndChecksTable
                loading={loading}
                data={actionsAndChecks}
              />
            </div>
          }
          heading={'Actions & Checks'}
          actionsAndChecksCurrent={true}
        />
      </div>
    </AccessWrapper>
  );
}
